
import React from 'react';
import '../../styles/Contact/hero.css'; // Ensure path is correct

const HeroSection = () => {
  return (
    <section className="hero-sectionContact">
      {/* 1. The Dark Overlay (Background) */}
      <div className="hero-overlay"></div>

      {/* 2. The Content (Foreground) */}
      <div className="container hero-content">
        <div className="row justify-content-center justify-content-md-start">
          <div className="col-12 col-md-10 col-lg-8">
            
            {/* Breadcrumb */}
            <div className="mb-2">
              <span className="text-white-50 fw-bold">Home</span>
              <span className="mx-2 text-white-50">|</span>
              <span className="text-white fw-bold">Contact</span>
            </div>

            {/* Headline */}
            <h1 className="display-4 text-white fw-bold">
              How May We Help You?
            </h1>
            
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;